import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { CanColor, mixinColor } from '@angular/material/core';
import { Constructor } from '@mtna/core-ts';

export class RdsCatalogHeaderBase {
  constructor(public _elementRef: ElementRef) {}
}

export const _RdsCatalogHeaderMixinBase: Constructor<CanColor> & typeof RdsCatalogHeaderBase = mixinColor(RdsCatalogHeaderBase, 'primary');

@Component({
  selector: 'rds-c-catalog-header',
  template: ` {{ name }} `,
  styles: [
    `
      rds-c-catalog-header {
        display: block;
        border-radius: 3px;
        font-size: 14px;
        font-weight: 600;
        line-height: 28px;
        padding-left: 1rem;
        padding-right: 1rem;
        margin-top: 2rem;
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsCatalogHeaderComponent extends _RdsCatalogHeaderMixinBase implements CanColor {
  @HostBinding('attr.role') role = 'heading';

  @Input() name = '';

  /** Theme color, defaults to primary */
  @Input() color: 'primary' | 'accent' = 'primary';

  constructor(private elementRef: ElementRef) {
    super(elementRef);
  }
}
